import React from "react";
import Button from "@material-ui/core/Button";

function FloaterDetails(props) {
  const { video } = props;

  const onClickScrollTop = () => {
    window.scrollTo({ top: 400, behavior: "smooth" });
  };

  return (
    <div>
      <div className="details__floater--wrapper">
        <div
          className="thumbnail"
          style={{ backgroundImage: `url(${video.imgUrl})` }}
        />
        <div className="title">{video.publishingTitle}</div>
      </div>
      <Button onClick={onClickScrollTop}>License Video</Button>
    </div>
  );
}

export default FloaterDetails;
